export default class FilterArticle {

    constructor($view) {
        this.$view = $view;
        this.$customSelect = this.$view.find(".form-control.custom-select");
        this.href = this.$view.find(".filter-href").data('href');
        this.bind();
    }

    bind() {
        this.$customSelect.on("change", (e) => {
            let $this = $(e.target);
            window.location.href = this.href + "?" + $this.attr('name') + "=" + $this.val();
        });
    }
}